module.exports = __webpack_public_path__ + "static/media/17-RefusingToBeAMan.caf8e627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/17-RefusingToBeAMan.jpg
// module id = 151
// module chunks = 0